// src/components/LeasePricingSection.jsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './LeasePricingSection.css';

export default function LeasePricingSection() {
  const [isYearly, setIsYearly] = useState(false);

  const leasePlans = [
    {
      name: 'Basis',
      priceMonthly: 39.99,
      priceYearly: (39.99 * 12 * 0.95).toFixed(2),
      features: [
        'One-page website',
        'Responsive (mobiel, tablet, desktop)',
        'Basis SEO & indexatie',
        'Beveiliging (SSL & basis firewall)',
        'Maandelijkse updates en onderhoud',
      ],
    },
    {
      name: 'Professioneel',
      priceMonthly: 89.99,
      priceYearly: (89.99 * 12 * 0.95).toFixed(2),
      popular: true,
      features: [
        'Website tot 5 pagina’s',
        'Responsive & snel geladen',
        'Geavanceerde SEO optimalisatie',
        'Beveiliging & updates',
        'Maandelijks onderhoud + rapportage',
      ],
    },
    {
      name: 'Maatwerk',
      priceMonthly: 199.99,
      priceYearly: (199.99 * 12 * 0.95).toFixed(2),
      features: [
        'Onbeperkt aantal pagina’s',
        'Geavanceerde functionaliteiten',
        '100% custom design',
        'Premium support',
        'Inclusief alle updates & onderhoud',
      ],
    },
  ];

  return (
    <section id="lease-pricing" className="lease-pricing-section py-5">
      <div className="container">

        {/* Sectie header */}
        <header className="text-center mb-5">
          <h2 className="lease-title">Website lease pakketten</h2>
          <p className="lease-subtitle">
            Lease professionele websites zonder hoge opstartkosten. Eén vast bedrag per maand of per jaar.
          </p>
        </header>

        {/* Betaalwijze switch */}
        <div className="payment-toggle d-flex justify-content-center align-items-center mb-5">
          <span className={!isYearly ? 'toggle-label active' : 'toggle-label'}>Maandelijks</span>
          <label className="custom-switch mx-3">
            <input
              type="checkbox"
              checked={isYearly}
              onChange={() => setIsYearly(!isYearly)}
            />
            <span className="slider"></span>
          </label>
          <span className={isYearly ? 'toggle-label active' : 'toggle-label'}>Jaarabonnement</span>
        </div>

        <div className="row gy-4 gx-lg-4 justify-content-center">
          {leasePlans.map((plan, idx) => (
            <div key={idx} className="col-12 col-md-6 col-lg-4">
              <article className={`lease-card shadow-sm ${plan.popular ? 'lease-card--popular' : ''}`}>
                {plan.popular && <span className="badge-popular">Populair</span>}

                <h3 className="lease-name text-center mb-2">{plan.name}</h3>

                {/* Prijsweergave */}
                <div className="text-center mb-4">
                  {isYearly ? (
                    <>
                      <small className="original-price">
                        €{(plan.priceMonthly * 12).toFixed(2)} per jaar
                      </small>
                      <div className="lease-price">
                        <span className="currency">€</span>
                        <span className="amount">{plan.priceYearly}</span>
                      </div>
                      <div className="period">per jaar (5% korting)</div>
                    </>
                  ) : (
                    <>
                      <div className="lease-price">
                        <span className="currency">€</span>
                        <span className="amount">{plan.priceMonthly}</span>
                      </div>
                      <div className="period">per maand (excl. btw)</div>
                    </>
                  )}
                </div>

                <ul className="lease-feature-list mb-4">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="lease-feature-item">
                      <FontAwesomeIcon icon={faCheckCircle} className="me-2 lease-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <a
                  href="/contact"
                  className="btn btn-lg w-100 btn-orange"
                  role="button"
                  aria-label={`Contact over ${plan.name}`}
                >
                  Kies {plan.name}
                </a>
              </article>
            </div>
          ))}
        </div>

        <p className="text-center mt-4 small">
          * Geen eenmalige kosten of verborgen toeslagen: je betaalt alleen het vaste {isYearly ? 'jaarbedrag' : 'maandbedrag'}.
        </p>
      </div>
    </section>
  );
}
